import { render, staticRenderFns } from "./StockTrfPrintDetails_Items.vue?vue&type=template&id=7a7956c4&"
import script from "./StockTrfPrintDetails_Items.vue?vue&type=script&lang=js&"
export * from "./StockTrfPrintDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports